import { runtime } from "@codeArt/common";

const { send, on, off } = require("./ipc");

const service = {
    open:(serviceName,accept)=>{
        return new Promise((resolve, reject) => {
            try{
                send("service:open",{serviceName}).then(({ok})=>{
                    if(ok && accept){
                        on(`${serviceName}-accept.temp`,accept);
                    }
                    resolve();
                }).catch(reject);
            }catch(ex){
                reject(ex);
            }
        });
    },
    close:(serviceName)=>{
        send("service:close",{serviceName});
        off(`${serviceName}-accept.temp`);
    },
    invoke:(serviceName,arg)=>{
        return send(serviceName,arg);
    },
    one:(serviceName,arg)=>{    //打开服务一次，执行1次，关闭
        return new Promise((resolve, reject) => {
            try{
                service.open(serviceName).then(()=>{
                    service.invoke(serviceName,arg).then((r)=>{
                        service.close(serviceName);
                        resolve(r);
                    }).catch((e)=>{
                        service.close(serviceName);
                        reject(e);
                    });
                }).catch(reject);
            }catch(ex){
                reject(ex);
            }
        });
    }
};

export {service};
